import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { CreateMac } from "../../routes/cryptography";
import FileDownload from "js-file-download";
import { Buffer } from "buffer"

class Mac extends Component {
  constructor() {
    super();
    this.state = {
      data: "",

      filename: "файл",

      fileIsOpen: false,
      isValidFileSize: true,

      errors: {},
    };
    ///////VerifySign Func////
    this.handleInputChangeDataMac = this.handleInputChangeDataMac.bind(this);
    this.handleFileForMacChange = this.handleFileForMacChange.bind(this);
    this.handleMacSubmit = this.handleMacSubmit.bind(this);
  }

  componentDidMount() { }

  handleInputChangeDataMac(e) {
    //console.log(e.target.value);
    try {
      if (e.target.value.length === 0) {
        //console.log("ok");
        document.getElementById("dataForMac").disabled = false;
      } else {
        document.getElementById("dataForMac").disabled = true;
      }
      this.setState({
        filename: "файл",
        fileIsOpen: false,
        // signFileName: "файл",
        // signFileIsOpen: false,
        // certFileName: "файл",
        // certFileIsOpen: false,

        data: btoa(unescape(encodeURIComponent(e.target.value))),
      });
      //console.log(e.target.value.length);

      // console.log(e.target.value);
    } catch (error) {
      //console.log(error);
    }
  }

  handleFileForMacChange() {
    try {
      const file = document.getElementById("dataForMac").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {

        document.getElementById("inputDataMac").disabled = true;
        this.setState({ filename: file.name, isValidFileSize: true, fileIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            data: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        document.getElementById("inputDataMac").disabled = false;

        this.setState({ filename: "файл", isValidFileSize: false, fileIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleMacSubmit(e) {
    e.preventDefault();
    try {
      CreateMac(this.state.data).then((res) => {
        try {
          //console.log(res);
          if (res.status === 200) {
            FileDownload(res.data.mac, "mac.pem");
            document.getElementById("view").style.borderColor = "green";
          } else {
            document.getElementById("view").style.borderColor = "red";
          }
        } catch (error) {
          document.getElementById("view").style.borderColor = "red";

          //console.log(error);
        }
      });
    } catch (error) {
      //console.log(error);
    }
  }

  render() {
    return (
      <div className="container">
        <h4 className="major">Mac-значение</h4>
        <Form onSubmit={this.handleMacSubmit}>
          <div className="sm-4">
            <Form.Group>
              <Form.Label>Введите текст</Form.Label>
              <Form.Control
                id="inputDataMac"
                onChange={this.handleInputChangeDataMac}
                type="text"
                placeholder="Текст"
                style={{ color: "white" }}
              />
            </Form.Group>

            <Form.Label style={{ marginLeft: "50%" }}>или</Form.Label>

            <Form.Group>
              <Form.Label>Выберите файл </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="dataForMac"
                  onChange={this.handleFileForMacChange}
                  isValid={this.state.fileIsOpen}
                  isInvalid={!this.state.isValidFileSize}

                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.filename}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>

            <Button
              style={{ float: "right" }}
              type="submit"
              size="sm"
            >
              Создать
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(Mac));
